<template>
  <v-card class="activity-log-card" :style="`max-height: ${maxHeight ?? '100vh'};`" color="transparent" elevation="0">
    <v-card-title class="py-2 px-3 text-subtitle-1">
      <v-icon left small>mdi-history</v-icon>
      User Activity
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text class="pa-0" style="overflow-y: auto;" :style="`max-height: calc(${maxHeight ?? '100vh'} - 49px)`">
      <v-timeline dense clipped v-if="items && items.length" class="py-2 pr-2 pl-0 no-left-space">
        <v-timeline-item
          v-for="log in items"
          :key="log.id"
          fill-dot
          left
          small
          color="primary"
          class="py-1"
        >
          <template v-slot:icon>
            <v-avatar size="30">
              <img :src="log.profile_url" :alt="log.created_by_label">
            </v-avatar>
          </template>

          <v-card class="elevation-1 ml-0">
            <v-card-title class="py-1 px-2 text-caption d-flex justify-space-between">
              <span class="primary--text font-weight-bold">{{ log.created_by_label }}</span>
              <span class="grey--text text--darken-1 font-weight-regular">
                {{ new Date(log.created_at).toLocaleString('en-GB') }}
              </span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-2">
              <json-viewer
                :value="log.log"
                :expand-depth="0"
                boxed
                sort
                theme="my-awesome-json-theme"
              ></json-viewer>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
      <div v-else class="text-center my-5 grey--text">
        <v-icon large color="grey lighten-1">mdi-emoticon-sad-outline</v-icon>
        <p class="mt-2 text-caption">No logs to display...</p>
      </div>
    </v-card-text>
     <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="50"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import JsonViewer from 'vue-json-viewer'
import 'vue-json-viewer/style.css'

export default {
  components: { JsonViewer },
  props: ['model', 'ref_id', 'maxHeight'],
  data: () => ({
    items: [],
    loading: false,
  }),
  watch: {
    model: 'getItems',
    ref_id: 'getItems',
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      if (!this.model || !this.ref_id) return;

      this.loading = true;
      this.$axios.get(`/api/user-activities/${this.model}/${this.ref_id}`)
        .then((resp) => {
          this.items = resp.data;
        })
        .catch(error => {
          console.error("Error fetching activity logs:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
}
</script>

<style lang="scss">
.activity-log-card {
  display: flex;
  flex-direction: column;
}

.v-timeline.no-left-space {
  // Removes space between the timeline line and the content card
  ::v-deep .v-timeline-item__body {
    padding-left: 0 !important;
  }

  // Reduces the width of the divider containing the dot
  ::v-deep .v-timeline-item__divider {
    min-width: 32px !important; 
  }
}

.jv-container.my-awesome-json-theme {
  background: #fdfdfd;
  border: 1px solid #ededed;
  border-radius: 4px; 
  white-space: nowrap;
  color: #333;
  font-size: 12px;
  font-family: 'Consolas', 'Menlo', 'Courier New', monospace;

  .jv-code {
    padding: 5px 10px !important;
  }

  .jv-ellipsis {
    font-size: 0.8em;
    padding: 0px 3px 1px 3px;
  }

  .jv-key {
    color: #8b8a8a;
  }

  .jv-item {
    &.jv-boolean, &.jv-number { color: #c92c6d; }
    &.jv-string {
      color: #3a8a3a;
      word-break: break-word;
      white-space: normal;
    }
  }
}
</style>